import React, { ReactNode } from "react";

interface ActionFormWrapperProps {
  children?: ReactNode;
  title: string | ReactNode;
  hook: string | ReactNode;
}

const ActionFormWrapper = ({
  children,
  title,
  hook,
}: ActionFormWrapperProps) => {
  return (
    <>
      <div className="card rounded-[20px] border-[4px] border-[#0F3256] bg-[#164A7C] flex flex-col columns-1 items-center justify-center py-8 gap-2 px-4 mb-4 text-[#DDDDDD]">
        <div className="font-bold text-2xl">{title}</div>
        <div className="text-base text-center my-1">{hook}</div>
        <div className="flex items-center justify-center text-sm w-full">
          {children}
        </div>
      </div>
    </>
  );
};

export default ActionFormWrapper;
